import { db } from '../firebase';
//import _ from 'lodash'
import moment from 'moment'

const refMyApplicaitons = db.ref('myApplications')

export const removeListenerMyApplications = (userId)=>{
    refMyApplicaitons.child(userId).off()
}


export const doAddApplication = async (eventId, userId) =>{
  
   const currentCountSnap = await db.ref('/counter/myApplications/').child(userId).once('value')

   const currentCount = currentCountSnap.exists() ? currentCountSnap.val().count : 0
   const newCount = currentCount+1
   const timeStamp = moment().format()
   const updates = {}
   updates['/myApplications/' + userId + '/' + eventId ] = eventId
   updates['/canidates/'+ eventId + '/' + userId] = {eventId: eventId, timeStamp: timeStamp}
   updates['/counter/myApplications/' + userId + '/count'] = newCount
   
   db.ref().update(updates)

}

export const doDeleteApplication = async (eventId, userId) => {
    
    const currentCountSnap = await db.ref('/counter/myApplications').child(userId).once('value')
    const currentCount = currentCountSnap.val().count
    const newCount = currentCount-1
    const updates = {}
    updates['/myApplications/' + userId + '/' + eventId ] = null
    updates['/canidates/'+ eventId + '/' + userId] = null
    updates['/counter/myApplications/' + userId + '/count'] = newCount
    db.ref().update(updates)

}









// WEBPACK FOOTER //
// ./src/firebase/database/handleApplications.js